var map = {
	"./abb-color.svg": 1765,
	"./afb-color.svg": 1766,
	"./afb.svg": 1767,
	"./agro-color.svg": 1768,
	"./alb-color.svg": 1769,
	"./alb.svg": 1770,
	"./amb-color.svg": 1771,
	"./amb.svg": 1772,
	"./bbbaidja-color.svg": 1773,
	"./bbbaidjaxxx-color.svg": 1774,
	"./bdinidjaxxx-color.svg": 1775,
	"./bimb-color.svg": 1776,
	"./bimb.svg": 1777,
	"./bkr-color.svg": 1778,
	"./bkr.svg": 1779,
	"./bmriidja-color.svg": 1780,
	"./bniaidja-color.svg": 1781,
	"./bninidja-color.svg": 1782,
	"./bninidjaxxx-color.svg": 1783,
	"./boc-color.svg": 1784,
	"./bpay-color.svg": 1785,
	"./brinidja002-color.svg": 1786,
	"./bsmdidjaxxx-color.svg": 1787,
	"./bsn-color.svg": 1788,
	"./bsn.svg": 1789,
	"./btanidjaxxx-color.svg": 1790,
	"./cenaidja-color.svg": 1791,
	"./cenaidjaxxx-color.svg": 1792,
	"./cimb-color.svg": 1793,
	"./cimb.svg": 1794,
	"./citi-color.svg": 1795,
	"./citi.svg": 1796,
	"./default-bank-icon-color.png": 1797,
	"./default-bank-icon.png": 1798,
	"./gxbank-color.svg": 1799,
	"./hlb-color.svg": 1800,
	"./hlb.svg": 1801,
	"./hsbc-color.svg": 1802,
	"./hsbc.svg": 1803,
	"./ibbkidjaxxx-color.svg": 1804,
	"./kfh-color.svg": 1805,
	"./kwh-color.svg": 1806,
	"./kwh.svg": 1807,
	"./mbb-color.svg": 1808,
	"./mbb.svg": 1809,
	"./muamalat-color.svg": 1810,
	"./nispidjaxxx-color.svg": 1811,
	"./ocbc-color.svg": 1812,
	"./ocbc.svg": 1813,
	"./pbb-color.svg": 1814,
	"./pbb.svg": 1815,
	"./pinbidja-color.svg": 1816,
	"./raykat-color.svg": 1817,
	"./rhb-b.svg": 1818,
	"./rhb-color-b.svg": 1819,
	"./rhb-color.svg": 1820,
	"./rhb.svg": 1821,
	"./scb-color.svg": 1822,
	"./scb.svg": 1823,
	"./tng-color.svg": 1824,
	"./uob-color.svg": 1825,
	"./uob.svg": 1826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;